// extracted by mini-css-extract-plugin
export default {"termsHint":"TermsHint_termsHint__7I+0U","termsLink":"TermsHint_termsLink__O9xtD"};